import React from 'react'

const Block = (props) => {
  const { offset, width, columnCount, children } = props
  const colScale = 12 / columnCount

  return (
    <div style={{ marginBottom: '0.75rem' }}
         className={'col-12 col-lg-' + (Math.round(width * colScale)) + (
           offset
             ? ' offset-lg-' + (Math.round(offset * colScale))
             : ''
         )}
    >
      {children}
    </div>
  )
}

export default Block
